import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "@fontsource/caveat/400.css";
import "@fontsource/dancing-script/400.css";
import "@fontsource/homemade-apple/400.css";
import "@fontsource/mrs-saint-delafield/400.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/layout.css";
import "./styles/components.css";
import "./styles/screens.css";
import "./styles/viewer.css";
import "./styles/responsive.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

// `?theme=light|dark` pins the colour scheme (handy for reviews and screenshots); otherwise the system's is used.
const theme = new URLSearchParams(window.location.search).get("theme");
if (theme === "light" || theme === "dark") document.documentElement.setAttribute("data-theme", theme);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
